export enum ConversationExperimentEnum {
  ConversationTopic = 'conversation_topic',
  SentimentAnalysis = 'sentiment_analysis',
  ConversationOutcome = 'conversation_outcome',
}
